import { PostType } from "../../../../types/scheduled-post"

const POST_TYPE_OPTIONS: { type: PostType; icon: string; name: string; desc: string }[] = [
  { type: "carousel", icon: "🎠",  name: "カルーセル", desc: "複数枚スライド" },
  { type: "story",    icon: "📱",  name: "ストーリー", desc: "24時間表示" },
  { type: "reel",     icon: "🎬",  name: "リール",     desc: "ショート動画" },
  { type: "feed",     icon: "🖼️",  name: "フィード",   desc: "通常の投稿" },
]

type Props = {
  value: PostType
  onChange: (type: PostType) => void
}

const PostTypeSelector = ({ value, onChange }: Props) => (
  <section className="post-create-form__section">
    <h2 className="post-create-form__section-title">投稿タイプ</h2>
    <div className="post-type-grid">
      {POST_TYPE_OPTIONS.map(opt => (
        <div
          key={opt.type}
          className={`post-type-card ${value === opt.type ? "post-type-card--selected" : ""}`}
          onClick={() => onChange(opt.type)}
          role="button"
          tabIndex={0}
          onKeyDown={e => e.key === "Enter" && onChange(opt.type)}
        >
          <div className="post-type-card__icon">{opt.icon}</div>
          <div className="post-type-card__name">{opt.name}</div>
          <div className="post-type-card__desc">{opt.desc}</div>
        </div>
      ))}
    </div>
  </section>
)

export default PostTypeSelector
